// src/HomeRedirect.js
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
import Home from "./pages/home/Home";

const HomeRedirect = () => {
  const { token, user, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-emerald-50 to-blue-50">
        <div className="text-2xl text-emerald-600 animate-spin">🏅</div>
      </div>
    );
  }

  // If NOT logged in → Show public Home page
  if (!token || !user) {
    return <Home />;
  }

  // If logged in → Redirect to role-specific dashboard
  const role = (user.role || "").toString().toLowerCase();
  switch (role) {
    case "admin":
    case "secretary":
      return <Navigate to="/admin" replace />;
    case "district":
      return <Navigate to="/district" replace />;
    case "coach":
      return <Navigate to="/coach" replace />;
    case "manager":
      return <Navigate to="/manager" replace />;
    case "camp_official":
      return <Navigate to="/camp-official" replace />;
    case "regular_manager":
    case "regular_official":
      return <Navigate to="/staff" replace />;
    case "player":
      return <Navigate to="/player" replace />;
    default:
      return <Home />;
  }
};

export default HomeRedirect;
